import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = {
  class: "card relative z-2",
  style: {}
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href", "target"]

import Menubar from 'primevue/menubar';
import 'primeicons/primeicons.css';
import { MenuItem } from 'primevue/menuitem';

const __default__ = {
  name: 'app',
  data() {
    return {
      privacyItems: [
        {
          label: 'Privacy & Terms of Service',
          route: '/privacy'
        }
      ],

      items: [
        {
          label: 'Home',
          route: '/'
        },
        {
          label: 'Services',
          route: '/services'
        },
        {
          label: 'Corporate',
          route: '/corporate'
        },
        {
          label: 'Pricing',
          route: '/pricing'
        },
        {
          label: 'Gift Cards',
          route: '/gift-cards'
        },
        {
          label: 'About',
          route: '/about_us'
        },
        {
          label: 'FAQ',
          route: '/faq'
        },
      ]
    }
  }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Menubar), {
      model: (_ctx.items.concat(_ctx.privacyItems as []) as MenuItem[])
    }, {
      start: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("a", {
          href: "/",
          style: {"margin-right":"1em"}
        }, [
          _createElementVNode("img", {
            alt: "Dragonfly Massage",
            src: _imports_0,
            height: "44",
            class: "mr-2"
          })
        ], -1)
      ])),
      item: _withCtx(({ label, item, props, root }) => [
        (item.route)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: item.route,
              custom: ""
            }, {
              default: _withCtx((routerProps) => [
                _createElementVNode("a", _mergeProps({
                  href: routerProps.href
                }, props.action), [
                  _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.icon)), null, 16),
                  _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.label)), _toDisplayString(label), 17)
                ], 16, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("a", _mergeProps({
              key: 1,
              href: item.url,
              target: item.target
            }, props.action), [
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.icon)), null, 16),
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.label)), _toDisplayString(label), 17),
              _createElementVNode("span", _mergeProps({
                class: [root ? 'pi pi-fw pi-angle-down' : 'pi pi-fw pi-angle-right']
              }, props.submenuicon), null, 16)
            ], 16, _hoisted_3))
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_router_view),
    _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"max-width":"100em","width":"95%"} }, [
      _createElementVNode("footer", null, [
        _createElementVNode("br"),
        _createElementVNode("br"),
        _createElementVNode("hr"),
        _createElementVNode("i", null, "Every body is unique and worthy of special treatment!"),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            target: "_blank",
            rel: "noopener",
            href: "https://search.google.com/local/writereview?placeid=ChIJa3wQ4m5lz4cRI79yEvBpS-w"
          }, [
            _createElementVNode("i", {
              class: "pi pi-star",
              "aria-hidden": "true"
            }),
            _createTextVNode(" Enjoyed your session? Leave a review on Google ")
          ])
        ])
      ])
    ], -1))
  ]))
}
}

})